"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useState } from "react";
import ReactCountUp from "react-countup";
import { useFilterSearch } from "../hooks/use-filter-search";
import { useLocale } from "../hooks/use-locale";
import { cn } from "../utils/cn";
export function CountUp(t0) {
  const $ = _c(25);
  const {
    children,
    className,
    initialCount
  } = t0;
  const locale = useLocale();
  const results = useFilterSearch();
  const totalHits = results.data?.pages[0]?.totalHits ?? initialCount ?? 0;
  let t1;
  if ($[0] !== locale) {
    t1 = 1000 .toLocaleString(locale).slice(1, 2);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const separator = t1;
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== locale || $[5] !== totalHits) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = /\d/g;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = totalHits.toLocaleString(locale).replace(t5, "8");
    $[4] = locale;
    $[5] = totalHits;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const display = t4;
  let t5;
  if ($[8] !== className) {
    t5 = cn(className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== display) {
    t6 = <span aria-hidden={true} className="invisible col-start-1 row-start-1" suppressHydrationWarning={true}>{display}</span>;
    $[10] = display;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== mounted || $[13] !== separator || $[14] !== totalHits) {
    t7 = mounted ? <ReactCountUp duration={1.5} end={totalHits} preserveValue={true} separator={separator} start={0} /> : "0";
    $[12] = mounted;
    $[13] = separator;
    $[14] = totalHits;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <span className="col-start-1 row-start-1">{t7}</span>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <span className="inline-grid whitespace-nowrap">{t6}{t8}</span>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== children || $[22] !== t5 || $[23] !== t9) {
    t10 = <span className={t5}>{t9}{children}</span>;
    $[21] = children;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}